import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';

import type { ISbStoryData } from '@storyblok/js';
import { DynamicModule } from 'ng-dynamic-component';
import type { Observable } from 'rxjs';
import { tap } from 'rxjs';

import { PageComponent } from '@valk-nx/storyblok/components/page/src/lib/page.component';
import { DealDetailComponent } from '@valk-nx/storyblok/pages/deal-detail/src/lib/deal-detail.component';
import { EventDetailComponent } from '@valk-nx/storyblok/pages/event-detail/src/lib/event-detail.component';
import { EventOverviewComponent } from '@valk-nx/storyblok/pages/event-overview/src/lib/event-overview.component';
import { FilterableList } from '@valk-nx/storyblok/pages/filterable-list/src/lib/filterable-list';
import { GuestAppPageComponent } from '@valk-nx/storyblok/pages/guest-app-page/src/lib/guest-app-page.component';
import { HotelByDealDetailComponent } from '@valk-nx/storyblok/pages/hotel-by-deal-detail/src/lib/hotel-by-deal-detail.component';
import { MeetingRoomDetailComponent } from '@valk-nx/storyblok/pages/meeting-room-detail/src/lib/meeting-room-detail.component';
import { MeetingRoomOverviewComponent } from '@valk-nx/storyblok/pages/meeting-room-overview/src/lib/meeting-room-overview.component';
import { MiniHotelComponent } from '@valk-nx/storyblok/pages/mini-hotel/src/lib/mini-hotel.component';
import { PackageDetailComponent } from '@valk-nx/storyblok/pages/package-detail/src/lib/package-detail.component';
import { PackageOverviewComponent } from '@valk-nx/storyblok/pages/package-overview/src/lib/package-overview.component';
import { PromotionCodeComponent } from '@valk-nx/storyblok/pages/promotion-code/src/lib/promotion-code.component';
import { RoomDetailComponent } from '@valk-nx/storyblok/pages/room-detail/src/lib/room-detail.component';
import { RoomOverviewComponent } from '@valk-nx/storyblok/pages/room-overview/src/lib/room-overview.component';
import { StoryblokHelper } from '@valk-nx/storyblok-helpers/src/lib/general/storyblok.helper';
import { StoryblokService } from '@valk-nx/storyblok-services/src/lib/services/storyblok.service';
import { PageSettingsStore } from '@valk-nx/storyblok-store/src/lib/store/page-settings/page-settings.store';

const Components = {
	block: PageComponent,
	staticPage: PageComponent,
	dealDetail: DealDetailComponent,
	eventDetail: EventDetailComponent,
	eventOverview: EventOverviewComponent,
	guestAppPage: GuestAppPageComponent,
	hotelByDealDetail: HotelByDealDetailComponent,
	filterableList: FilterableList,
	miniHotelPage: MiniHotelComponent,
	packageDetail: PackageDetailComponent,
	packageOverview: PackageOverviewComponent,
	page: PageComponent,
	menulessPage: PageComponent,
	meetingRoomOverview: MeetingRoomOverviewComponent,
	meetingRoomDetail: MeetingRoomDetailComponent,
	roomDetail: RoomDetailComponent,
	roomOverview: RoomOverviewComponent,
	promotionCodePage: PromotionCodeComponent,
};
@Component({
	selector: 'sb-root',
	templateUrl: './root.component.html',
	host: { class: 'block min-h-[70vh]' },
	imports: [CommonModule, DynamicModule],
})
export class SbRootComponent {
	private readonly sbService = inject(StoryblokService);

	readonly pageSettingsStore = inject(PageSettingsStore);
	readonly story$: Observable<ISbStoryData>;
	components = Components;

	constructor() {
		this.story$ = this.sbService.story$.pipe(
			tap({
				next: (story) => {
					StoryblokHelper.checkNegativeHeader(story.content);

					const hideMenu = story.content.component === 'menulessPage';
					const hideFooter =
						story.content.component === 'menulessPage';
					this.pageSettingsStore.updateState({
						hideMenu,
						hideFooter,
					});
				},
			}),
		);
	}
}
